
import { AppService } from "app/services/app.service";
import { AppFilter } from "app/models/app-filter.model";
import { Observable } from "rxjs";

export abstract class AbMorador extends AppService {
  abstract deletarMorador(id: number);
  abstract getAllMoradores(filter: AppFilter): Observable<any>;
}